const QUERIES = {
  USERS_LIST: 'users-list',
  PRODUCTS_LIST: 'products-list',
}

export {QUERIES}
